export default __webpack_public_path__ + "static/media/govt-small-icon.de87b9a7.svg";